export default __webpack_public_path__ + "c87ceefc43ac1a01af943b1f8932a5a8.svg";